module.exports = __webpack_public_path__ + "static/media/job-offers.d8273e35.svg";